import BaseStore from './BaseStore'

export class ManualStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'manuals'
  }
}

export default new ManualStore()


// WEBPACK FOOTER //
// ./src/stores/ManualStore.js